import React from 'react'

const UpfrontIcon = ({ width = '44px', height = '44px', fill = 'white' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 45 44"
            fill="none"
        >
            <path
                d="M32.925 11.7151L28.9925 7.78262L26.875 9.90012L32.925 15.9501L43.5125 5.36262L41.395 3.24512L32.925 11.7151ZM16.2875 5.96762L14.17 3.85012L10.2375 7.78262L6.305 3.85012L4.1875 5.96762L8.12 9.90012L4.1875 13.8326L6.305 15.9501L10.2375 12.0176L14.17 15.9501L16.2875 13.8326L12.355 9.90012L16.2875 5.96762ZM16.2875 30.1676L14.17 28.0501L10.2375 31.9826L6.305 28.0501L4.1875 30.1676L8.12 34.1001L4.1875 38.0326L6.305 40.1501L10.2375 36.2176L14.17 40.1501L16.2875 38.0326L12.355 34.1001L16.2875 30.1676Z"
                fill={fill}
            />
            <path
                d="M23.8516 20.4877V0.825195H20.8266V20.4877H1.16406V23.5127H20.8266V43.1752H23.8516V23.5127H43.5141V20.4877H23.8516Z"
                fill={fill}
            />
        </svg>
    );
};

export default UpfrontIcon